import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { getAllAnnouncements } from "../../store/actions/announcement";

// import { css } from "aphrodite-jss";
import { Link } from "react-router-dom";
import style from "../../thema/style";
import { PUBLIC_URL } from "../../config";
import Cart from "./Cart";
import Search from "./Search";
import Navigation from "./Navigation";
import { Helmet } from "react-helmet";

class HeaderTop extends Component {
  constructor(props) {
    super(props);
    // Carousel için bir ref oluştur
    this.carouselRef = React.createRef();
  }

  componentDidMount() {
    console.log(
      "announcementannouncementannouncement:",
      this.props.announcement
    );
    !this.props.announcement.announcements && this.props.getAllAnnouncements();

    if (this.carouselRef.current) {
      window.jQuery(this.carouselRef.current).carousel({
        interval: 4000,
        ride: "carousel",
      });
    }
  }

  render() {
    if (this.props.announcement.fetching) return null;

    return (
      this.props.announcement.announcements &&
      this.props.announcement.announcements.length > 0 && (
        <div
          className="row"
          style={{
            padding: 6,
            fontSize: 15,
            color:
              this.props.setting.setting &&
              this.props.setting.setting.annocoment.color,
            backgroundColor:
              this.props.setting.setting &&
              this.props.setting.setting.annocoment.bg,
          }}
        >
          <div className="col-md-12">
            <div className="container">
              <div className="row">
                <div
                  ref={this.carouselRef}
                  id="carouselExampleSlidesOnly2"
                  className="carousel slide w-100 text-center"
                  data-ride="carousel"
                >
                  <div className="carousel-inner">
                    {this.props.announcement.announcements.map(
                      (item, index) => (
                        <div
                          key={`announcement-${index}`}
                          className={
                            index === 0
                              ? "carousel-item active"
                              : "carousel-item"
                          }
                        >
                          <div className="d-block w-100">
                            <Link
                              className={"annocoment-item-link"}
                              to={item.link}
                              // to={{
                              //   pathname: `/kategori/${category.slug}`,
                              //   state: { category: category },
                              // }}
                            >
                              {item.title}
                            </Link>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                  <a
                    class="carousel-control-prev"
                    href="#carouselExampleSlidesOnly2"
                    role="button"
                    data-slide="prev"
                    style={{ transform: "scale(0.7)" }}
                  >
                    <FontAwesomeIcon icon={["fas", "circle"]} size="xs" />
                    <span class="sr-only">Previous</span>
                  </a>
                  <a
                    class="carousel-control-next"
                    href="#carouselExampleSlidesOnly2"
                    role="button"
                    data-slide="next"
                    style={{ transform: "scale(0.7)" }}
                  >
                    <FontAwesomeIcon icon={["fas", "circle"]} size="xs" />
                    <span class="sr-only">Next</span>
                  </a>
                </div>

                {/* <div
                id="carouselAnnacomentsControls"
                className={"carousel slide w-100"}
                data-ride="carousel"
              >
                <div className={"carousel-inner text-center"}>
                  {Array(5)
                    .fill(null)
                    .map((v, index) => (
                      <div
                        className={
                          index === 0 ? "carousel-item active" : "carousel-item"
                        }
                        key={index}
                      >
                        Merhaba
                      </div>
                    ))}
                </div>
                 <a
                  className={"carousel-control-prev"}
                  href="#carouselAnnacomentsControls"
                  role="button"
                  data-slide="prev"
                >
                  <span
                    className={"carousel-control-prev-icon"}
                    aria-hidden="true"
                  />
                  <span className={"sr-only"}>Previous</span>
                </a>
                <a
                  className="carousel-control-next"
                  href="#carouselAnnacomentsControls"
                  role="button"
                  data-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  />
                  <span className="sr-only">Next</span>
                </a> 
              </div> */}
              </div>
            </div>
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = ({
  announcement,
  customer,
  setting,
  page,
  category,
  product,
}) => {
  return {
    announcement,
    customer,
    setting,
    page,
    category,
    product,
  };
};

const mapDispatchToProps = { getAllAnnouncements };

export default connect(mapStateToProps, mapDispatchToProps)(HeaderTop);



// WEBPACK FOOTER //
// ./src/components/shared/HeaderTop.js